import _ from "lodash";
import {Auth} from "../components/Authorization";
import {SnackBar} from "../components/common";
import {getActionData} from "_helpers";
import {expertPaymentService} from "_services";
import {alertMessages, expertPaymentConstants} from "_constants";

function listExperts(params) {
    return (dispatch) => {
        dispatch(getActionData(expertPaymentConstants.LIST_EXPERT_PAYMENT_REQUEST));
        expertPaymentService.listExperts(params)
            .then(response => {
                dispatch(getActionData(expertPaymentConstants.LIST_EXPERT_PAYMENT_SUCCESS, response.data));
            }).catch((error) => {
            const status = _.get(error, 'response.status');
            if (status === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(expertPaymentConstants.LIST_EXPERT_PAYMENT_FAILURE, {}, error));
            handleErrorMessage(error);
        });
    }
}

function clearBalance(payload) {
    console.log("payload: ",payload);
    return (dispatch) => {
        dispatch(getActionData(expertPaymentConstants.CLEAR_EXPERT_BALANCE_REQUEST));
        expertPaymentService.clearBalance(payload)
            .then(response => {
                dispatch(getActionData(expertPaymentConstants.CLEAR_EXPERT_BALANCE_SUCCESS, response.data));
            }).catch((error) => {
            const status = _.get(error, 'response.status');
            if (status === 401) {
                Auth.processLogout();
                return;
            }
            dispatch(getActionData(expertPaymentConstants.CLEAR_EXPERT_BALANCE_FAILURE, {}, error?.response?.data));
            handleErrorMessage(error);
        });
    }
}

function handleErrorMessage(error) {
    const status = _.get(error, 'response.status');
    const messageFromServer = _.get(error, 'response.data.message');
    const message = (status === 404)
        ? alertMessages.GENERIC_NOT_FOUND
        : (messageFromServer || alertMessages.GENERIC_ERROR);
    SnackBar.showMessage(message);
}

export const expertPaymentActions = {
    listExperts,
    clearBalance,
};